import { render, staticRenderFns } from "./TechSolutions.vue?vue&type=template&id=6420818f&scoped=true"
import script from "./TechSolutions.vue?vue&type=script&lang=js"
export * from "./TechSolutions.vue?vue&type=script&lang=js"
import style0 from "./TechSolutions.vue?vue&type=style&index=0&id=6420818f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6420818f",
  null
  
)

export default component.exports